document.addEventListener('DOMContentLoaded', function() {
  // Select all Collection Navigation Switcher sections on the page
  const sections = document.querySelectorAll('.home-featured-collection-grid');
  sections.forEach(function(section) {
    const swiperContainer = section.querySelector('.home-featured-collection-grid__swiper');
    if (!swiperContainer) return;

    // Pagination element scoped to this section
    const paginationEl = swiperContainer.querySelector('.swiper-pagination.home-featured-collection-grid__swiper-pagination');

    // Initialize Swiper instance for this switcher
    const swiperInstance = new Swiper(swiperContainer, {
      loop: true,
      spaceBetween: 6,
      slidesPerView: 2,
      centeredSlides: true,
      pagination: { el: paginationEl, type: 'progressbar' },
      grabCursor: true,
      freeMode: true,
      mousewheel: { forceToAxis: true, sensitivity: 1, releaseOnEdges: true },
      watchOverflow: true,
      breakpoints: {
        400:  { loop: false, slidesPerView: 2,    centeredSlides: false, spaceBetween: 8 },
        600:  { loop: false, slidesPerView: 1.9,  centeredSlides: false, spaceBetween: 10 },
        800:  { loop: false, slidesPerView: 2.25, centeredSlides: false, spaceBetween: 10 },
        900:  { loop: false, slidesPerView: 2.75, centeredSlides: false, spaceBetween: 8 },
        1100: { loop: false, slidesPerView: 3.25, centeredSlides: false, spaceBetween: 8 },
        1200: { loop: false, slidesPerView: 4,    centeredSlides: false, spaceBetween: 8 },
        1600: { loop: false, slidesPerView: 5,    centeredSlides: false, spaceBetween: 8 }
      }
    });

    // Scope bullets and slides to this section only
    const bullets = section.querySelectorAll('.home-featured-collection-grid__bullet-title');
    const slides  = section.querySelectorAll('.home-featured-collection-grid__card.swiper-slide');

    function filterByCategory(category) {
      slides.forEach(slide => {
        slide.style.display = (slide.dataset.categoryName === category) ? '' : 'none';
      });
      swiperInstance.update();
    }

    bullets.forEach(bullet => {
      bullet.addEventListener('click', () => {
        bullets.forEach(b => b.classList.remove('home-featured-collection-grid__bullet-title-active'));
        bullet.classList.add('home-featured-collection-grid__bullet-title-active');
        filterByCategory(bullet.dataset.categoryName);
      });
    });

    // Activate first category by default
    if (bullets.length) bullets[0].click();
  });
});
